import React from "react";
import { WithBackground } from "../../common";

const refresh = () => {
  document.location.href = "/jobs";
};

const InternalServer = () => (
  <WithBackground img="https://www.hrgo.co.uk/media/5314/hrgo404b.jpg">
    <div className="d-flex align-items-center p-4">
      <div className="text mt-5">
        <h1 className="subheading">Sorry….It’s not you, it’s us!</h1>
        <h2 className="mb-2">We’re experiencing an internal server problem.</h2>
        <p>Please come back and try again later.</p>
        <p>
          <button onClick={refresh} className="btn btn-primary">
            Back
          </button>
        </p>
      </div>
    </div>
  </WithBackground>
);

export default InternalServer;
